import { ThunkAction } from 'redux-thunk';
import { IContext, IState } from '../../store';
import { openDemandRequestModal } from './requestDemand';
import { trackBannerClick } from '../../components/demand/utils/tracking';

export const openForm = (): ThunkAction<void, IState, IContext> => {
  return dispatch => {
    dispatch(openDemandRequestModal());

    trackBannerClick();
  };
};
